import type { ImmutableObject } from "@/lib/immutable";
import type { PackageItem } from "../../../../hooks/useInventoryState";
import { useStorefrontSettingsState } from "../../../../hooks/useStorefrontSettingsState";
import { useTranslate } from "../../../../hooks/useTranslate/useTranslate";

export type ProductDetailsPackageItemAvailabilityProps = {
	packageItem: ImmutableObject<PackageItem>;
};
export const ProductDetailsPackageItemAvailability: React.FC<
	ProductDetailsPackageItemAvailabilityProps
> = (props) => {
	const translate = useTranslate();
	const packageItem = props.packageItem;
	const totalIn = packageItem.Availability?.TotalIn ?? 0;

	const storefrontSettingsState = useStorefrontSettingsState();
	const hideAvailabilityForAccessoryItems =
		storefrontSettingsState.get().settings?.HideAvailabilityForAccessoryItems ??
		false;
	const showOwnedQty =
		storefrontSettingsState.get().settings?.ShowOwnedQty ?? false;
	if (hideAvailabilityForAccessoryItems || totalIn <= 0) {
		return null;
	}

	let available = "";
	available += totalIn.toString();
	if (showOwnedQty) {
		available += ` ${translate("of")} ${(packageItem.Availability?.Total ?? 0).toString()}`;
	}
	available += ` ${translate("Available")}`;

	return (
		<>
			{packageItem.Availability && (
				<div className="field availability text-muted-foreground whitespace-nowrap text-xs flex justify-center">
					({available})
				</div>
			)}
		</>
	);
};
